/* eslint-disable no-param-reassign */
import axios from 'axios';
import { base } from '../../config/config';

class Result {
  constructor(moviesList, pages, totalRes) {
    this.moviesList = moviesList;
    this.pages = pages;
    this.totalRes = totalRes;
  }
}

export default {
  state: {
    nowPlaying: {
      movies: [],
      activePage: null,
      pages: '',
      totalRes: '',
    },
    upComming: {
      movies: [],
      activePage: null,
      pages: '',
      totalRes: '',
    },
    popular: {
      movies: [],
      activePage: null,
      pages: '',
      totalRes: '',
    },
    topRated: {
      movies: [],
      activePage: null,
      pages: '',
      totalRes: '',
    },
    homePrev: {
      nowPlaying: {
        movies: [],
      },
      upComming: {
        movies: [],
      },
      popular: {
        movies: [],
      },
      topRated: {
        movies: [],
      },
    },
  },
  mutations: {
    setMovieResults(state, {
      result, category, page, home,
    }) {
      let stateObject;

      if (!home) {
        switch (category) {
          case 'now_playing':
            stateObject = state.nowPlaying;
            break;
          case 'upcoming':
            stateObject = state.upComming;
            break;
          case 'popular':
            stateObject = state.popular;
            break;
          case 'top_rated':
            stateObject = state.topRated;
            break;
          default:
            stateObject = state.nowPlaying;
        }

        result.moviesList.forEach((element) => {
          stateObject.movies.push(element);
        });
        stateObject.activePage = page;
        stateObject.pages = result.pages;
        stateObject.totalRes = result.totalRes;
      } else {
        switch (category) {
          case 'now_playing':
            stateObject = state.homePrev.nowPlaying;
            break;
          case 'upcoming':
            stateObject = state.homePrev.upComming;
            break;
          case 'popular':
            stateObject = state.homePrev.popular;
            break;
          case 'top_rated':
            stateObject = state.homePrev.topRated;
            break;
          default:
            stateObject = state.homePrev.popular;
        }

        stateObject.movies = result.moviesList.slice(0, 6);
      }
    },
  },
  actions: {
    async getQuickMovieResults({ commit, state }, { category, page = 1, home = null }) {
      if (home === null) {
        let stateObject;
        switch (category) {
          case 'now_playing':
            stateObject = state.nowPlaying;
            break;
          case 'upcoming':
            stateObject = state.upComming;
            break;
          case 'popular':
            stateObject = state.popular;
            break;
          case 'top_rated':
            stateObject = state.topRated;
            break;
          default:
        }
        // don´t fetch again if activePage already set
        if (stateObject.activePage) {
          console.log(`stateObject.activePage: ${stateObject.activePage}, givenPage: ${page}`);

          if (page === stateObject.activePage || page < stateObject.activePage) {
            return;
          }
        }
      }

      commit('clearError');
      commit('setLoading', true);

      // console.log('fetching results for category: ', category);

      try {
        const url = `${base.urlPrefix}/movie/${category}?api_key=${base.key}&${
          base.language
        }&page=${page}&${base.region}`;

        const response = await axios.get(url);
        const { data } = response;

        const result = new Result(
          data.results,
          data.total_pages,
          data.total_results,
        );

        commit('setMovieResults', {
          result, category, page, home,
        });
        commit('setLoading', false);
      } catch (error) {
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getQuickTotalMovieRes(state) {
      return (pageName) => {
        switch (pageName) {
          case 'now':
            return state.nowPlaying.totalRes;
          case 'up-comming':
            return state.upComming.totalRes;
          case 'popular':
            return state.popular.totalRes;
          case 'top-rated':
            return state.topRated.totalRes;
          default:
            return state.popular.totalRes;
        }
      };
    },
  },
};
